import { render, staticRenderFns } from "./StockViewRevision.vue?vue&type=template&id=1b3dae87"
import script from "./StockViewRevision.vue?vue&type=script&lang=js"
export * from "./StockViewRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports